import { post } from "@/utils/utils";

const stock = {
  state: {},
  mutations: {
    SET_STOCK_MGT_CONFIG() {},
    QUERY_STOCK_SKU_LIST() {},
    QUERY_STOCK_LIST() {},
    QUERY_ALL_STOCK_LIST() {},
    QUERY_ALL_STOCK_FLOW() {},
    QUERY_STOCK_FLOW() {},
    GET_STOCK_MGT_CONFIG() {},
    QUERY_STOCK_CHANGE_TYPE() {},
    SET_CURRENT_STOCK() {},
    QUERY_PURCHASE_LIST() {}
  },
  actions: {
    queryPurchaseList({ commit }, params) {
      return post({
        commit,
        url: `/basic/spu/sku_list`,
        name: "QUERY_PURCHASE_LIST",
        params
      });
    },
    setCurrentStock({ commit }, params) {
      return post({
        commit,
        url: `/basic/stock/adjust`,
        name: "SET_CURRENT_STOCK",
        params
      });
    },
    setStockMgtConfig({ commit }, params) {
      return post({
        commit,
        url: `/basic/stock/config_edit`,
        name: "SET_STOCK_MGT_CONFIG",
        params
      });
    },
    getStockMgtConfig({ commit }, params) {
      return post({
        commit,
        url: `/basic/stock/config_detail`,
        name: "GET_STOCK_MGT_CONFIG",
        params
      });
    },
    queryStockChangeType({ commit }, params) {
      return post({
        commit,
        url: `/sys/common/dict_items?dictCode=stock_change_type`,
        name: "QUERY_STOCK_CHANGE_TYPE",
        params
      });
    },
    queryStockSkuList({ commit }, params) {
      return post({
        commit,
        url: `/basic/stock/sku_list`,
        name: "QUERY_STOCK_SKU_LIST",
        params
      });
    },
    queryStockList({ commit }, params) {
      return post({
        commit,
        url: `/basic/stock/list`,
        name: "QUERY_STOCK_LIST",
        params
      });
    },
    queryAllStockList({ commit }, params) {
      return post({
        commit,
        url: `/basic/stock/list`,
        name: "QUERY_ALL_STOCK_LIST",
        params
      });
    },
    queryStockFlow({ commit }, params) {
      return post({
        commit,
        url: `/basic/stock/flow`,
        name: "QUERY_STOCK_FLOW",
        params
      });
    },
    queryAllStockFlow({ commit }, params) {
      return post({
        commit,
        url: `/basic/stock/flow`,
        name: "QUERY_ALL_STOCK_FLOW",
        params
      });
    }
  }
};

export default stock;
